import React from "react";

const HeroSection = () => {
  return (
    <div
      id="carouselExampleAutoplaying"
      className="carousel md:mb-[3rem] mb-[1rem] slide "
      data-bs-ride="carousel"
    >

      <div className=" carousel-inner ">
        <div className="carousel-item active relative  ">
          <img src='https://ik.imagekit.io/mctozv7td/Mirpur%20Jewelers/signal-2024-03-28-074238_002.jpeg?updatedAt=1711593823158' alt="Mirpur Jewellers Banner" width="1600" height="900" className="md:mt-[0rem] mt-[4rem]" />

    
        </div>

      </div>
    </div>
  );
};

export default HeroSection;
